<template>
  <div class="my-4">
    <div class="flex gap-3 items-center">
      <a class="min-w-32 h-10 py-1 bg-black rounded overflow-hidden" href="https://apps.apple.com/se/app/bokabord-restauranger/id545302312" target="_blank">
        <img class="h-full mx-auto w-auto" src="~/assets/images/badge-app-store.png" :alt="$t('shared.appPromo.appStore')" />
      </a>
      <a class="min-w-32 h-10 py-1 bg-black rounded overflow-hidden" href="https://play.google.com/store/apps/details?id=com.bokabord&amp;hl=sv" target="_blank">
        <img class="h-full mx-auto w-auto" src="~/assets/images/badge-google-play.png" :alt="$t('shared.appPromo.playStore')" />
      </a>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  block: Object
})
</script>

<style lang="scss" scoped>
//
</style>